'use strict';

import {fabric} from 'fabric';
export default fabric.Color;



/** WEBPACK FOOTER **
 ** ./src/Color.js
 **/